import PropTypes from "prop-types";
import React, { useMemo } from "react";
import { IconContext } from "react-icons";

const IconText = ({ icon, text }) => {
  const iconStyle = useMemo(
    () => ({ style: { verticalAlign: "baseline", marginBottom: "-2px" } }),
    []
  );

  return (
    <React.Fragment>
      <IconContext.Provider value={iconStyle}>{icon}</IconContext.Provider>{" "}
      {text}
    </React.Fragment>
  );
};

IconText.propTypes = {
  icon: PropTypes.node.isRequired,
  text: PropTypes.string.isRequired,
};

export default IconText;
